"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presentSkillDetails = presentSkillDetails;
exports.presentSkills = presentSkills;
exports.skillAsText = skillAsText;
var _solidUi = require("solid-ui");
function skillAsText(store, sk) {
  if (sk.termType === 'Literal') return '';
  const directName = store.anyJS(sk, _solidUi.ns.schema('name'));
  if (directName) return directName;

  // Canonical shape: entry node -> solid:publicId -> schema:name.
  const publicId = store.any(sk, _solidUi.ns.solid('publicId'));
  if (publicId && publicId.termType === 'NamedNode') {
    const name = store.anyJS(publicId, _solidUi.ns.schema('name'));
    if (name) return name;
    return _solidUi.utils.label(publicId, true);
  }
  return '';
}
function presentSkillDetails(subject, store) {
  return store.each(subject, _solidUi.ns.schema('skills')).filter(sk => sk.termType !== 'Literal').map(sk => {
    const publicId = store.any(sk, _solidUi.ns.solid('publicId'));
    const publicIdUri = publicId ? publicId.value : '';
    return {
      name: skillAsText(store, sk),
      publicId: publicIdUri,
      entryNode: sk
    };
  }).filter(detail => detail.name !== '');
}
function presentSkills(subject, store) {
  return presentSkillDetails(subject, store).map(detail => detail.name);
}